/* tslint:disable:max-line-length */
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import 'whatwg-fetch';
import {
  apiStatuses,
  checkDuplicateAndQuarantine as checkDuplicateAndQuarantineUnbound,
  CheckDuplicateAndQuarantine,
  FetchProductInfo,
  fetchProductInfo as fetchProductInfoUnbound,
  fetchUserInfoDeferred,
  userLoggedInDeferred,
} from '../actions/Actions';
import {
  IDuplicateAndQuarantine,
  IProductInfo,
  IReferer,
  IState,
  IUserInfo,
  IUserLoggedIn,
} from '../CustomTypes';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as queryString from 'query-string';
import { PropsWithChildren } from 'react';
import {
  alternativeOfferForUnderAgeUsers,
  getRedirectUrlInLocalStorage,
  lockedForOverAgeUsers,
  lowerAgeLimitYears,
} from '../fastflowUtils';
import {
  Button,
  classNames,
  FontSize,
  FontWeight,
  HeadingLevel,
  IconName,
  Margin,
  Padding,
  TextAlign,
  Width,
} from '@snoam/pinata';
import TopIcon from './TopIcon';
import { PageHeading } from './PageHeading';
import { getfullUrlPath } from '../PulseUtils';
import moment from 'moment';

const styleClass = {
  button: classNames(Width.W_FULL, Margin.MT_10, Margin.MB_4),
  heading: classNames(
    FontWeight.FONT_LIGHT,
    TextAlign.TEXT_CENTER,
    FontSize.TEXT_2XL,
    Padding.PB_4,
  ),
  ingress: classNames(TextAlign.TEXT_CENTER, FontSize.TEXT_LG),
};

export interface IProductWrapperParamProps {
  productInfo: IProductInfo;
  productId?: string;
  referer: IReferer;
  userInfo: IUserInfo;
}
export interface IProductWrapperActionProps {
  checkDuplicateAndQuarantine: CheckDuplicateAndQuarantine;
  fetchProductInfo: FetchProductInfo;
}

interface IQueryParams {
  redirectUri?: string;
  refererUri?: string;
  referer?: string;
}

export interface IProductWrapperProps
  extends IProductWrapperParamProps,
    RouteComponentProps<{ productId: string }>,
    IProductWrapperActionProps {
  hostname: string;
}
export interface IProductWrapperState {
  lockedByAgeTooHigh: boolean;
  lockedByAgeUnder18: boolean;
  lockedByAgeUnknown: boolean;
}

export class ProductWrapper extends React.Component<
  IProductWrapperProps,
  IProductWrapperState
> {
  public static displayName = 'ProductWrapper';

  constructor(props: IProductWrapperProps) {
    super(props);
    this.state = {
      lockedByAgeTooHigh: false,
      lockedByAgeUnder18: false,
      lockedByAgeUnknown: false,
    };
  }

  private loadData(props: IProductWrapperProps) {
    const { checkDuplicateAndQuarantine, fetchProductInfo } = props;
    const { pathname } = window.location;
    const { productId } = props.match.params;
    (fetchProductInfo(productId) as any).then((product: IProductInfo) => {
      document.title = `Kjøp ${product.header}`;
      userLoggedInDeferred.promise.then((user: IUserLoggedIn) => {
        (
          checkDuplicateAndQuarantine(
            product.productId,
            product.owningClient,
            user.spidId,
            user.sig,
          ) as any
        )
          .then((result: IDuplicateAndQuarantine) => {
            const query: IQueryParams = queryString.parse(
              props.location.search,
            ) as IQueryParams;
            fetchUserInfoDeferred.promise
              .then((userInfo: IUserInfo) => {
                const lockByAgeTooHigh = lockedForOverAgeUsers(
                  userInfo,
                  product,
                );
                const lockByAgeUnknown = !userInfo.birthDay;
                const lockByAgeUnder18 = moment().isBefore(
                  moment(userInfo.birthDay).add(lowerAgeLimitYears, 'years'),
                  'days',
                );
                const giveAlternativeOffer = alternativeOfferForUnderAgeUsers(
                  userInfo,
                  product,
                );
                if (
                  /\/receipt|\/placeorder|\/productquarantined|\/upgrade|\/components/.test(
                    pathname,
                  ) === false
                ) {
                  if (result.isDuplicate === true) {
                    props.history.push(
                      `/products/${productId}/receipt?duplicate=true&spidId=${
                        user.spidId
                      }&sig=${encodeURIComponent(user.sig || '')}${
                        query.redirectUri
                          ? `&redirectUri=${encodeURIComponent(
                              query.redirectUri,
                            )}`
                          : `&${getRedirectUrlInLocalStorage()}`
                      }`,
                    );
                  } else if (result.shouldUpgrade === true) {
                    const referer =
                      props.referer.referer ||
                      query.refererUri ||
                      query.referer ||
                      '';
                    props.history.push(
                      `/products/${productId}/upgrade?spidId=${
                        user.spidId
                      }&sig=${encodeURIComponent(
                        user.sig || '',
                      )}&referer=${encodeURIComponent(referer)}`,
                    );
                  } else if (result.isQuarantine === true) {
                    const referer =
                      props.referer.referer ||
                      query.refererUri ||
                      query.referer ||
                      '';
                    props.history.push(
                      `/products/${productId}/productquarantined?spidId=${
                        user.spidId
                      }&sig=${encodeURIComponent(
                        user.sig || '',
                      )}&referer=${encodeURIComponent(referer)}`,
                    );
                  } else if (lockByAgeTooHigh) {
                    this.setState({ lockedByAgeTooHigh: true });
                  } else if (lockByAgeUnknown) {
                    this.setState({ lockedByAgeUnknown: true });
                  } else if (lockByAgeUnder18) {
                    this.setState({ lockedByAgeUnder18: true });
                  } else if (giveAlternativeOffer) {
                    // Redirect the user to the correct age protected purchase form
                    const referer =
                      props.referer.referer ||
                      query.refererUri ||
                      query.referer ||
                      '';
                    window.location.replace(
                      `${getfullUrlPath()}products/${
                        product.ageLimitSubscriptionConfigurationId
                      }?redirectUri=${encodeURIComponent(
                        query.redirectUri || '',
                      )}&referer=${encodeURIComponent(referer)}`,
                    );
                  }
                }
              })
              .catch((e) => 'ignore'); // eslint-disable-line @typescript-eslint/no-unused-vars
          })
          .catch(() => 'ignore');
      });
    });
  }

  public render() {
    if (this.props.productInfo.apiStatus === apiStatuses.SUCCESS) {
      if (
        this.state.lockedByAgeTooHigh ||
        this.state.lockedByAgeUnknown ||
        this.state.lockedByAgeUnder18
      ) {
        const { owningClientName } = this.props.productInfo;
        const frontPageUrl = this.props.productInfo.myPageUrl
          .replace('minside', '')
          .replace('kundeportal', 'www');
        const heading = this.state.lockedByAgeTooHigh
          ? `Dette tilbudet er kun til de som er under ${this.props.productInfo.ageLimit} år`
          : `Du må være over ${lowerAgeLimitYears} år for å bestille abonnement.`;
        const link = this.state.lockedByAgeTooHigh ? (
          <a href={`https://kundeportal.${this.props.hostname}/bli-abonnent`}>
            <Button
              className={styleClass.button}
              text={'Her finner du våre andre tilbud'}
            />
          </a>
        ) : (
          <a href={frontPageUrl}>
            <Button
              className={styleClass.button}
              text={`Tilbake til ${owningClientName}`}
            />
          </a>
        );
        return (
          <>
            <TopIcon iconName={IconName.GIFT_OUTLINE} />
            <PageHeading level={HeadingLevel.ONE}>{heading}</PageHeading>
            {link}
          </>
        );
      }
      return <div>{this.props.children}</div>;
    }
    return null;
  }

  public UNSAFE_componentWillMount() {
    this.loadData(this.props);
  }

  public UNSAFE_componentWillReceiveProps(nextProps: IProductWrapperProps) {
    if (nextProps.productId !== this.props.productId) {
      this.loadData(nextProps);
    }
  }
}

export default connect<
  IProductWrapperParamProps,
  IProductWrapperActionProps,
  PropsWithChildren<Pick<IProductWrapperProps, 'hostname'>>
>(
  (state: IState) => ({
    productInfo: state.productInfo,
    referer: state.referer,
    userInfo: state.userInfo,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        checkDuplicateAndQuarantine: checkDuplicateAndQuarantineUnbound,
        fetchProductInfo: fetchProductInfoUnbound,
      },
      dispatch,
    ) as IProductWrapperActionProps,
)(withRouter(ProductWrapper));
